import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { OktaAuth } from '@okta/okta-auth-js';
import { Observable, BehaviorSubject, catchError, throwError } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { UserProfile } from '../model/user-profile';


@Injectable({ providedIn: 'root' })
export class UserService  {
  private userProfileSubject = new BehaviorSubject<UserProfile | null>(null);
  userProfile$ = this.userProfileSubject.asObservable();
  userDetails: any;
  constructor(
    private oktaAuth: OktaAuth,
    private router: Router
  ) { }
  isLoggedIn(): boolean {
    const userDetailsCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith('userDetails='));
    if (userDetailsCookie) {
      const userDetailsString = userDetailsCookie.split('=')[1];
      this.userDetails = JSON.parse(decodeURIComponent(userDetailsString));
    }
    const authenticated = this.userDetails.loggedIn;
    return authenticated;
  }
  //canActivate(): boolean {
  //  const userDetailsCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith('userDetails='));
  //  if (userDetailsCookie) {
  //    const userDetailsString = userDetailsCookie.split('=')[1];
  //    this.userDetails = JSON.parse(decodeURIComponent(userDetailsString));
  //  }
  //  const authenticated = this.userDetails.loggedIn;
  //  console.log("Authenticated canActive: " + authenticated);
  //  if (authenticated) {
  //    return true;
  //  }
  //  // Redirect to login page
  //  this.router.navigate(['/log-in']);
  //  return false;
  //}

  public async loadUserProfile(userClaims: any) {
    const userProfile: UserProfile = {
      firstName: userClaims?.given_name,
      lastName: userClaims?.family_name,
      email: userClaims?.email,
      fullName: userClaims?.name
    };
    this.userProfileSubject.next(userProfile);
    var cookieValue = this.getCookie();
    if (cookieValue === null || cookieValue === undefined || cookieValue === '') {
      var currentDay = new Date();
      document.cookie = "UserDetails = " + JSON.stringify(userClaims) + "; expires = " + new Date(currentDay.setDate(currentDay.getDate() + 30)).toUTCString() + "; path=/";
    }
  }

  public getCookie() {
    var cookieList = document.cookie.split(';');
    var value: string = '';
    cookieList.forEach((x) => {
      if (x.indexOf('UserDetails') > -1)
        value = x.split('=')[1];
    });
    return value;
  }
}
